import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const DataStructure = {
  isLoading: false,
  isError: false,
  layout: {} as any,
  itemOrder: [] as any,
};

const GetRoastCalculatorLayoutSlice = createSlice({
  name: "RoastCalulatorLayout",
  initialState: DataStructure,
  reducers: {
     setRostLayout(state:any,action:PayloadAction<any>) {
       const layoutData =
          action.payload[":items"]?.["root"]?.[":items"]?.["container"]?.[
            ":items"
          ]?.["container"];
        state.layout = layoutData?.[":items"]?.["roastcalculator"];
        state.itemOrder = layoutData?.[":itemsOrder"];
    },
  },
});
export const {setRostLayout} = GetRoastCalculatorLayoutSlice.actions
export const getRoastCalculatorLayoutSlice =
  GetRoastCalculatorLayoutSlice.reducer;
